import { render, staticRenderFns } from "./UserAllTickets.vue?vue&type=template&id=0a5c6bf2"
import script from "./UserAllTickets.vue?vue&type=script&lang=js"
export * from "./UserAllTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports